<script>
import { required, email } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import api from "../../../api";
import {
  authMethods,
  authFackMethods,
  notificationMethods
} from "@/state/helpers";
// import store from '../../../state/store';
import router from '../../../router';
// import cookie from 'cookiejs';

// import md5 from "js-md5";
// import crypto from 'crypto'

// var secret    = 'pateintlink'; //make this your secret!!
function sleep(seconds) {
  return new Promise(resolve => setTimeout(resolve, seconds * 1000));
}

export default {
  data() {
    return {
      // practices: [],
      email: "",
      password: "",
      submitted: false,
      loading: false,
      qrCode: null,
      emailCode: '',
      authCode: ''
    };
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  created() {
    document.body.classList.add("auth-body-bg");
  },
  validations: {
    email: { required, email },
    password: { required }
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    timer() {
      let timerInterval;
      Swal.fire({
        title: "Logged in successfully",
        html: "Please wait while we load your practice data.",
        timer: 3000,
        timerProgressBar: true,
        showCancelButton: false,
        showConfirmButton: false,
        onBeforeOpen: () => {
          Swal.showLoading();
          // timerInterval = setInterval(() => {
          //   Swal.getContent().querySelector(
          //     "b"
          //   ).textContent = Swal.getTimerLeft();
          // }, 100);
        },
        onClose: () => {
          clearInterval(timerInterval);
        }
      }).then(result => {
        if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.timer
        ) {
          console.log("I was closed by the timer"); // eslint-disable-line
        }
      });
    },
    async emailLogin() {

      try {
        const data = {
          email: this.email,
          password: this.password,
          code: this.emailCode
        }
        const response = await api.post('/api/users/login-via-code', data)
        const user = response.data.user


        if(user.active) {
          this.$bvModal.hide('twofa')	
          sessionStorage.setItem('currentUser', JSON.stringify(
            {
              id: user.id,
              name: user.name,
              email: user.email,
              isAdmin: user.isAdmin,
              token: response.data.token,
              permissions: user.permissions,
              role: user.role
            })
          )
          this.timer();
          await this.setPracticeVals(user);
          await sleep(3)
          router.go(router.currentRoute)

        } else {
          Swal.fire("User Login Failed!", "User is not active, please contact Administrator for access.", "error");
        }
      } catch (e) {
        console.log(e);
        this.emailCode = ''
        Swal.fire("Code not matched!", "Please try again", "warning");
      }

    },
    async authLogin() {

      try {
        const data = {
          email: this.email,
          password: this.password,
          code: this.authCode
        }
        const response = await api.post('/api/users/login-via-auth', data)
        const user = response.data.user

        if(user.active) {
          this.$bvModal.hide('twofa')	
          sessionStorage.setItem('currentUser', JSON.stringify(
            {
              id: user.id,
              name: user.name,
              email: user.email,
              isAdmin: user.isAdmin,
              token: response.data.token,
              permissions: user.permissions,
              role: user.role
            })
          )
          this.timer();
          await this.setPracticeVals(user);
          await sleep(3)
          router.go(router.currentRoute)

        } else {
          Swal.fire("User Login Failed!", "User is not active, please contact Administrator for access.", "error");
        }
      } catch (e) {
        console.log(e);
        this.authCode = ''
        Swal.fire("Code not matched!", "Please try again", "warning");
      }

    },
    tryToLogIn() {
      var self = this;
      var data = {
        email: this.email,
        password: this.password,
      };
      self.loading = true;
      api.post('/api/users/login', data)
      .then(async (response) => {
        self.loading = false;
        // console.log('data', response.data);

        if(response.data.user) {
          if(response.data.user.name == 'Super Admin') {
            var superAdmin = response.data.user;

            sessionStorage.setItem('currentUser', JSON.stringify(
            {
              id: superAdmin.id,
              name: superAdmin.name,
              email: superAdmin.email,
              isAdmin: superAdmin.isAdmin,
              token: response.data.token,
              permissions: superAdmin.permissions,
            }))
            this.timer();
            // Swal.fire("User logined!", "User logined Successfully!", "success");
            await self.setPracticeVals(superAdmin);
            sleep(3).then(() => {router.push({name: 'Pages', params: { cmsId: this.currentCms.id }})})
            
            // location.reload();
          }
        }

        else {
          this.qrCode = response.data.qr
          this.$bvModal.show('twofa')	
      
        }

      }, (error) => {
        self.loading = false;
        console.log(error);
        Swal.fire("Email or Password not matched!", "Please try again", "warning");
      });

    }
  }
};
</script>

<template>
  <div>
    <div class="home-btn d-none d-sm-block">
      <a href="/">
        <i class="mdi mdi-home-variant h2 text-white"></i>
      </a>
    </div>
    <div>
      <div class="container-fluid p-0">
        <div class="row no-gutters">
          <div class="col-lg-4">
            <div class="authentication-page-content p-4 d-flex align-items-center min-vh-100">
              <div class="w-100">
                <div class="row justify-content-center">
                  <div class="col-lg-9">
                    <div>
                      <div class="text-center">
                        <div>
                          <a href="/" class="logo">
                            <img src="@/assets/images/logo-dark.png" width="70%" alt="logo" />
                          </a>
                        </div>

                        <h4 class="font-size-18 mt-4">Welcome Back !</h4>
                        <p class="text-muted">Sign in to continue to Patient Link.</p>
                      </div>

                      <b-alert
                        variant="danger"
                        class="mt-3"
                        v-if="notification.message"
                        show
                        dismissible
                      >{{notification.message}}</b-alert>

                      <div class="p-2 mt-5">
                        <form class="form-horizontal" @submit.prevent="tryToLogIn">
                          <div class="form-group auth-form-group-custom mb-4">
                            <i class="ri-mail-line auti-custom-input-icon"></i>
                            <label for="email">Email</label>
                            <input
                              type="email"
                              v-model="email"
                              class="form-control"
                              id="email"
                              placeholder="Enter email"
                              :class="{ 'is-invalid': submitted && $v.email.$error }"
                            />
                            <div v-if="submitted && $v.email.$error" class="invalid-feedback">
                              <span v-if="!$v.email.required">Email is required.</span>
                              <span v-if="!$v.email.email">Please enter valid email.</span>
                            </div>
                          </div>

                          <div class="form-group auth-form-group-custom mb-4">
                            <i class="ri-lock-2-line auti-custom-input-icon"></i>
                            <label for="userpassword">Password</label>
                            <input
                              v-model="password"
                              type="password"
                              class="form-control"
                              id="userpassword"
                              placeholder="Enter password"
                              :class="{ 'is-invalid': submitted && $v.password.$error }"
                            />
                            <div
                              v-if="submitted && !$v.password.required"
                              class="invalid-feedback"
                            >Password is required.</div>
                          </div>

                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              class="custom-control-input"
                              id="customControlInline"
                            />
                            <label
                              class="custom-control-label"
                              for="customControlInline"
                            >Remember me</label>
                          </div>

                          <div v-if="loading" class="mt-4 text-center">
                            <div class="spinner-border text-info" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                          </div>

                          <div v-else class="mt-4 text-center">
                            <button
                              class="btn btn-primary w-md waves-effect waves-light"
                              type="submit"
                            >Log In</button>
                          </div>

                          <div class="mt-4 text-center">
                            <router-link tag="a" to="/forgot-password" class="text-muted">
                              <i class="mdi mdi-lock mr-1"></i> Forgot your password?
                            </router-link>
                          </div>
                        </form>
                      </div>

                      <b-modal no-close-on-backdrop
                        id="twofa"
                        centered
                        title="Two Factor Authentication"
                        title-class="font-18"
                        @ok="handleOk"
                        ok-title="Login"
                        hide-footer
                      >
                        <div class="row">
                          <div class="col-10">
                            <input
                              v-model="emailCode"
                              type="text"
                              name="emailCode"
                              class="form-control"
                              placeholder="Enter Email Code"
                            />
                          </div>
                          <div class="col-2 pl-1">
                            <b-button variant="primary" @click="emailLogin"
                            :disabled="!emailCode.length ? true: false">Login</b-button>
                          </div>
                        </div>

                        <div class="row">
                          <div v-if="qrCode" class="col-12">
                            <p class="text-center mt-4 mb-1">OR</p>
                            <div class="text-center">
                              <img :src="qrCode">
                              <p>Scan this QR code using any Authenticator app.</p>
                            </div>
                          </div>
                          <div v-else class="col-12">
                            <p class="text-center mt-4">OR</p>
                          </div>
                          <div class="col-10">
                            <input
                              v-model="authCode"
                              type="text"
                              name="emailCode"
                              class="form-control"
                              placeholder="Enter Auth Code"
                            />
                          </div>
                          <div class="col-2 pl-1">
                            <b-button variant="primary" @click="authLogin"
                            :disabled="!authCode.length ? true: false">Login</b-button>
                          </div>
                        </div>
                      </b-modal>

                      <!-- <div class="mt-5 text-center">
                        <p>
                          Don't have an account ?
                          <router-link
                            tag="a"
                            to="/register"
                            class="font-weight-medium text-primary"
                          >Register</router-link>
                        </p>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="authentication-bg">
              <div class="bg-overlay"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>